import React from 'react';
import * as PropTypes from 'prop-types';
import {
    Col,
    Row
} from '@snsw/react-component-library';
import { PersonalDisasterEligibilityPage } from '../PersonalDisaster';
import { BusinessDisasterEligibilityPage } from '../BusinessDisaster';
import { useApplicationConfig } from '../../store';
import { ErrorSummaryType } from './EligibilityPageProjectArchetypeValidator';

export const EligibilityPageProjectArchetype = ({ type = 'personalDisaster', errors, showErrors = false }: EligibilityPageObjectParams) => {
    const appConfig = useApplicationConfig();
    const showDebug = appConfig.appConfig?.enableDebug || false;

    const debugInfoRow = <Row>
        <Col span={ 12 } style={ { backgroundColor: 'lightgrey', borderStyle: 'dotted', borderWidth: '5px' } }>
            <h2> Debug information</h2>
            <i>This panel shows because the 'enableDebug' flag is switched on in 'appConfig'</i>
            <p>This is the {type} project archetype is selected but no implementation is provided. <br />
                <i>
                    This is defined in the
                    <strong>gaas-react-component-library</strong>
                    component <strong>EligibilityPageProjectArchetype</strong>
                </i>
            </p>
        </Col>
    </Row>;

    switch (type) {
        case 'personalDisaster': return <PersonalDisasterEligibilityPage errors={ errors } showErrors={ showErrors } />;
        case 'businessDisaster': return <BusinessDisasterEligibilityPage errors={ errors } showErrors={ showErrors } />;
        default: return <>{ showDebug && debugInfoRow}</>;
    }
};

interface EligibilityPageObjectParams {
    type: string,
    errors: ErrorSummaryType,
    showErrors?: boolean
}

EligibilityPageProjectArchetype.propTypes = {
    type: PropTypes.oneOf(['personalDisaster', 'businessDisaster', 'personalRental']).isRequired,
    errors: PropTypes.object,
    showErrors: PropTypes.bool
};

